import { Injectable } from '@angular/core';

import { asyncScheduler, map, Observable, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectActiveEmployee } from '@state/employees';
import { Employee } from '@shared/classes/employee.class';
import { EmployeeLogout } from '@state/router';
import { observeOn, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ActiveEmployeeGuard  {

  constructor(private store: Store) {
  }

  canActivate(): Observable<boolean> {
    return this.store.select(selectActiveEmployee).pipe(
      observeOn(asyncScheduler),
      map((employee: Employee): boolean => {
        return !!employee;
      }),

      tap((canActivate: boolean) => {
        if (!canActivate) {
          this.store.dispatch(EmployeeLogout());
        }
      }),

      take(1)
    );
  }

}
